import { useIntlayer } from 'react-intlayer';

import { HlsVideo } from '~/components/ui/hls-video';

export const HeroSection = () => {
  const { hero } = useIntlayer('landing');

  return (
    <section className="relative h-[100dvh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <HlsVideo
          src="/assets/video/hls/hero_section_2/master.m3u8"
          fallbackSrc="/assets/video/hero_section_2.mp4"
          className="absolute inset-0 size-full bg-black object-cover object-center w-full h-full"
          playsInline
          loop
          muted
          autoPlay
          aria-label="Background video"
          poster='/assets/images/first_frame.png'
        />
      </div>
      <h1 className="absolute left-[16px] right-[16px] bottom-[24px] lg:left-[80px] lg:right-[80px] lg:bottom-[80px] font-['Manrope','Manrope_Fallback',sans-serif] font-medium text-white text-[32px] leading-[1.2] lg:text-[76px] max-w-full">
        {hero.title}
      </h1>
    </section>
  );
};
